// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input___ntAU","Label":"Input_Label__Bph0J","InputElement":"Input_InputElement__2LtmH","Invalid":"Input_Invalid__1yNa3"};